<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid"
                 >
                  <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>

                                Tous les produits
                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                        @change="searchCustom"
                                ></v-text-field>
                            </v-card-title>
                            <div class="text-right pr-5">
                                <router-link :to="{name:'newproduit'}"
                                             style="background-color: #2A3042;color: #fff; margin-top: 2%; margin-left: 5%; font-size: 12pt"
                                             class="mb-2 btn">Nouveau produit
                                </router-link>
                            </div>
                            <v-data-table
                                    :headers="headers"
                                    :items="produits"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="prodloading"
                                    loading-text="Chargement en cours...">

                                <template v-slot:item.photo="{item}">
                                    <a v-if="item.photo" :href="item.photo" target="_blank">
                                        <img :src="item.photo"
                                             style="width: 50px; height: 50px;cursor: pointer; margin: 2% "
                                             data-toggle="modal" data-target="#infos"/>
                                    </a>
                                </template>

                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" max-width="1000px">

                                            <v-card style="padding-top: 5%">
                                                <v-card-title>
                                                    <span class="headline">{{ formTitle }}</span>
                                                </v-card-title>

                                                <v-card-text>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                    <v-btn color="blue darken-1" :disabled="!valid" text @click="save">
                                                        Sauvegarder
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                    <router-link :to="{name:'updateproduit',params: {id:item._id}}" class="mb-2 btn">
                                        <v-icon small class="mr-2">
                                            mdi-pencil
                                        </v-icon>
                                    </router-link>
                                    <v-icon small @click="deleteItem(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Actualiser</v-btn>
                                </template>
                            </v-data-table>
                            <div class="text-center">
                                <v-container>
                                    <v-row justify="center">
                                        <v-col cols="8">
                                            <v-container class="max-width">
                                                <v-pagination
                                                        v-model="page"
                                                        class="my-4"
                                                        :length="totalpage"
                                                        circle
                                                        prev-icon="mdi-menu-left"
                                                        next-icon="mdi-menu-right"
                                                        @input="clickCallback"
                                                ></v-pagination>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
           
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";

    export default {
        name: "Produit",
        components: {

        },
        data() {
            return {
                submitting: false,
                valid: true,
                page: 1,
                lazy: false,
                errors: undefined,
                overlay:true,
                search: '',
                dialog: '',
                user: JSON.parse(localStorage.getItem("user")),
                roles:JSON.parse(localStorage.getItem("mineroles")),
                GP:false,
                id: undefined,
                snackbar: false,
                textSnack: '',
                e1: 1,
                headers: [
                    {
                        text: 'Image',
                        align: 'start',
                        sortable: true,
                        value: 'photo',
                    },
                    {text: 'Référence', value: 'reference'},
                    {text: 'Dénomination', value: 'denomination'},
                    {text: 'Catégorie', value: 'categorie_slug.libel'},
                    {text: 'Forme', value: 'fp.nom'},
                    {text: 'Actions', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    code: '',
                    libel: '',
                    _id: 0,
                    created_at: 0,
                },
                libelRules: [
                    v => !!v || 'Libellé requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || 'Code requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouveau produit" : "Mise à jour"
            }
            ,
            ...mapState('produits/', ['produits','prodloading']),
            ...mapState('produits/', ['totalpage']),

        }
        ,
        mounted() {
        window.scrollTo(0,0);
            this.$store.dispatch('produits/getPaginate',this.page).then(response => {
                window.console.log('produits', response)
                 this.overlay = false;
            })
            console.log("this.roles",this.$store.state.produits);
            if (this.user.type_compte == "pharmacie")
            {
                if (!this.roles.includes("GP")){
                    this.$router.push("permission");
                }
            }
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            searchCustom() {
                this.overlay = true;
                if (this.search.length>0){
                    this.$store.dispatch('produits/getSearch',this.search).then(response => {
                        window.console.log('produits', response)
                        this.overlay = false;
                    });
                } else{
                    this.$store.dispatch('produits/getPaginate',1).then(response => {
                        window.console.log('produits', response.data)
                        this.overlay = false;
                    });
                }

            },

            clickCallback(pageNum) {
                this.overlay = true;
                this.$store.dispatch('produits/getPaginate',pageNum).then(response => {
                    window.console.log('produits', response)
                    this.overlay = false;
                });
            },

            editItem(item) {
                this.editedIndex = this.categories.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }
            ,

            deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('produits/deleteProduit', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                            Swal.fire({
                                icon: 'success',
                                timer: 3000,
                                timerProgressBar: false,
                                text: result.data.message,
                                position: 'top-end',
                                showConfirmButton: false
                            })
                        })
                    }
                })
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let data = new FormData();
                data.append("code", this.editedItem.code);
                data.append("libel", this.editedItem.libel);
                let mineroute = 'categories/setCategorie';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'categories/setUpdateCategorie';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>